const jobCardDescriptions = document.querySelectorAll('.job-card__description');

jobCardDescriptions.forEach((item) => {
  const { clientHeight, scrollHeight } = item;

  if (clientHeight < scrollHeight) {
    const { lineHeight } = getComputedStyle(item);
    const lines = Math.floor(clientHeight / parseFloat(lineHeight));
    console.log(lines);
    item.classList.add('trancate');
    item.style.setProperty('--lines', lines);
  }
});

if (document.getElementsByClassName('show-hide-content')[0]) {
  const showHideContentArr = document.querySelectorAll('.show-hide-content');

  showHideContentArr.forEach((content) => {
    const items = content.querySelectorAll('label');
    const btnShowHide = content.querySelector('.btn-show-hide');
    const maxVisibleItems = content.dataset.visible ? parseInt(content.dataset.visible, 10) : 7;

    if (!items.length || !btnShowHide) {
      return;
    }

    const applyVisibility = (isExpanded) => {
      items.forEach((item, index) => {
        const input = item.querySelector('input[type="checkbox"]');
        const isChecked = input && input.checked;
        const shouldHide = index > maxVisibleItems - 1 && !isChecked && !isExpanded;
        item.classList.toggle('hidden', shouldHide);
      });
    };

    applyVisibility(false);

    if (items.length > maxVisibleItems) {
      const btnCount = btnShowHide.querySelector('.btn-show-hide__count');
      btnShowHide.classList.add('is-visible');
      if (btnCount) {
        const hiddenItems = content.querySelectorAll('label.hidden').length;
        btnCount.textContent = `(${hiddenItems})`;
      }

      btnShowHide.addEventListener('click', () => {
        const isExpanded = !btnShowHide.classList.contains('active');
        btnShowHide.classList.toggle('active');
        applyVisibility(isExpanded);
      });
    }
  });
}

window.saveBtnInit = function saveBtnInit() {
  if(document.querySelector('.btn-save')) {
    const saveBtnArr = document.querySelectorAll('.btn-save');
    const site = document.querySelector('#site');

    saveBtnArr.forEach(btn => {
      const icon = btn.querySelector('.btn__icon');

      btn.addEventListener('click', () => {
        if(site.classList.contains('client-authorized') || site.classList.contains('candidate-authorized')) {

          if (icon.classList.contains('icon-star')) {
            icon.classList.remove('icon-star');
            icon.classList.add('icon-star-bg');
            /*icon.classList.add('!w-[19px]');*/
          } else {
            icon.classList.remove('icon-star-bg');
            /*icon.classList.remove('!w-[19px]');*/
            icon.classList.add('icon-star');
          }

        }
      })

    })
  }
}

saveBtnInit();
